import { render, staticRenderFns } from "./handleComment.vue?vue&type=template&id=a57b9108&scoped=true&"
import script from "./handleComment.vue?vue&type=script&lang=js&"
export * from "./handleComment.vue?vue&type=script&lang=js&"
import style0 from "./handleComment.vue?vue&type=style&index=0&id=a57b9108&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57b9108",
  null
  
)

export default component.exports